import { RouteRecordRaw } from 'vue-router';
import { RouteName } from "./routenames";
import Videos from './Videos.vue';
import Player from './Player.vue';

export const VideosRoute: RouteRecordRaw = {
    path: '/videos/',
    name: RouteName.VideosRoute,
    component: Videos,
    props: true,
};

export const VideoRoute: RouteRecordRaw = {
    path: '/videos/:categoryid/:seoname',
    name: RouteName.VideoRoute,
    component: Player,
    props: true,
};

export const CategoryRoute: RouteRecordRaw = {
    path: '/videos/:categoryid/',
    name: RouteName.CategoryRoute,
    component: Videos,
    props: true,
};

export const Routes: RouteRecordRaw[] = [
    VideosRoute,
    VideoRoute,
    CategoryRoute,
];
